__turbopack_context__.v({
  "body": "k0gqBq_body",
  "cancelButton": "k0gqBq_cancelButton",
  "closeButton": "k0gqBq_closeButton",
  "container": "k0gqBq_container",
  "deleteButton": "k0gqBq_deleteButton",
  "footer": "k0gqBq_footer",
  "footerButton": "k0gqBq_footerButton",
  "header": "k0gqBq_header",
  "headerTitle": "k0gqBq_headerTitle",
  "message": "k0gqBq_message",
  "warningIcon": "k0gqBq_warningIcon",
});
